
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 14v1.25a.74.74 0 01-.75.75h-8.5a.722.722 0 01-.75-.75V3.75A.74.74 0 011.25 3H3.5v9.25c0 .969.781 1.75 1.75 1.75h5.25zm0-10.75c0 .438.313.75.75.75h3.25v8.25a.74.74 0 01-.75.75h-8.5a.722.722 0 01-.75-.75V.75A.74.74 0 015.25 0h5.25v3.25zm3.75-.969c.156.156.25.344.25.531V3h-3V0h.188c.187 0 .374.094.53.25l2.032 2.031z","fill":"#100E2A"}})])
          )
        }
      }
    